export default function computeNewCellWidths({
  info,
  delta,
  widths,
  currentWidths,
}){

  return widths.map((w,ii) => {

    let { impactedRanges } = info;
    let impactedRangeCount = impactedRanges.length;

    if( impactedRangeCount === 1 ){ 
      let range = impactedRanges[0];
      let cellsImpacted = range[1] - range[0];
      let newCellWidth = Math.max(5, (widths[ii] + (delta/cellsImpacted)));
      return (
        range[0] <= ii && ii < range[1]
      ) ? newCellWidth : w
    }else if( impactedRangeCount > 1 ){

      let positionInImpactedRanges = impactedRanges.findIndex(range => {
        return range[0] <= ii && ii < range[1]
      });

      let columnToResizeInLeftRange = positionInImpactedRanges === 0;
      let columnToResizeInRightRange = positionInImpactedRanges === 1;
      let columnToResizeOutsideImpactedRanges = positionInImpactedRanges === -1;


      if( delta > 5 || delta < -5 ){
        //debugger;
      }

      if( delta === 0 || columnToResizeOutsideImpactedRanges ){
        return w;
      }
      else if( columnToResizeInLeftRange ){
        let rangeLen = impactedRanges[0][1] - impactedRanges[0][0];
        let increment = (delta / rangeLen)
        if( delta > 0 ){

          return Math.max(5,widths[ii] + increment);
        }else{
          return Math.max(5,widths[ii] + increment);
        }
      }else if( columnToResizeInRightRange ){

        let rangeLen = impactedRanges[1][1] - impactedRanges[1][0];
        let increment = (delta / rangeLen)


        if( delta > 0 ){
          return Math.max(5,widths[ii] - increment);
        }else{
          return Math.max(5,widths[ii] - increment);
        }

      }


    }

  })
}
